<div class="relative mx-auto flex max-w-2xl items-center" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
    <mat-form-field class="fuse-mat-dense fuse-mat-rounded w-full" appearance="fill" subscriptSizing="dynamic">
        <mat-icon matPrefix class="text-hint icon-size-5" svgIcon="mat_outline:search"></mat-icon>

        <input
            matInput
            [formControl]="searchControl"
            placeholder="Prompts durchsuchen..."
            class="min-w-0"
            autocomplete="off"
            role="combobox"
            aria-haspopup="listbox"
            aria-controls="search-results-listbox"
            aria-autocomplete="list"
            [attr.aria-expanded]="panelOpen()"
            (focus)="panelOpen.set(true)"
            (input)="panelOpen.set(true)"
            (keydown.escape)="closePanel()" />

        @if (searchControl.value) {
            <button mat-icon-button matSuffix (click)="clearSearch()" matTooltip="Suche löschen">
                <mat-icon class="icon-size-4" svgIcon="mat_outline:close"></mat-icon>
            </button>
        }
    </mat-form-field>
</div>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="panelOpen()"
    [cdkConnectedOverlayWidth]="overlayWidth()"
    cdkConnectedOverlayHasBackdrop
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    (backdropClick)="closePanel()"
    (detach)="closePanel()">
    <div
        id="search-results-listbox"
        class="bg-card max-h-160 w-full overflow-y-auto rounded-lg py-1 shadow-lg"
        role="listbox">
        @for (result of searchResults(); track result.item.prompt.uid) {
            <button
                type="button"
                class="hover:bg-hover flex w-full cursor-pointer flex-col gap-2 border-b border-black/5 px-4 py-3 text-left last:border-b-0"
                role="option"
                aria-selected="false"
                (click)="onSelect(result)">
                <!-- Directory -->
                <div class="flex items-center gap-2 text-blue-700">
                    <mat-icon
                        class="icon-size-5 text-blue-700"
                        [svgIcon]="getDirectoryIcon(result.item.directory)"></mat-icon>
                    <span
                        class="flex-1 truncate text-base font-semibold"
                        [innerHTML]="result.item.directory.name | highlight: searchQuery()"></span>
                </div>

                <!-- Prompt title -->
                <div class="ml-4 flex w-full items-start justify-between gap-2">
                    <span
                        class="flex-1 truncate text-base font-medium"
                        [innerHTML]="result.item.prompt.name | highlight: searchQuery()">
                    </span>

                    @if (copyOnSelect()) {
                        <mat-icon
                            class="icon-size-5 text-hint mr-1 mt-0.5 flex-shrink-0"
                            svgIcon="mat_outline:content_copy">
                        </mat-icon>
                    } @else {
                        <mat-icon
                            class="icon-size-5 text-hint mr-2 mt-0.5 flex-shrink-0"
                            svgIcon="mat_outline:open_in_browser">
                        </mat-icon>
                    }
                </div>

                <!-- Excerpt -->
                <div
                    class="text-secondary ml-4 border-l border-black/10 pl-2 text-base"
                    [innerHTML]="
                        result.item.prompt.text
                            | excerpt: searchQuery() : result.matches
                            | markdown
                            | highlight: searchQuery()
                    "></div>
            </button>
        } @empty {
            @if (searchQuery()) {
                <div class="text-hint flex items-center gap-2 px-4 py-3">
                    <mat-icon class="icon-size-4" svgIcon="mat_outline:search"></mat-icon>
                    <span class="text-base">Keine Prompts gefunden</span>
                </div>
            }
        }
    </div>
</ng-template>

<!-- Success Alert Overlay -->
@if (showAlert()) {
    <div class="fixed bottom-4 left-2 right-2 z-50">
        <fuse-alert
            [appearance]="'soft'"
            [type]="alert.type"
            [dismissible]="true"
            (dismissedChanged)="showAlert.set(false)">
            {{ alert.message }}
        </fuse-alert>
    </div>
}
